"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TileDataContextProvider = exports.useTileDataContext = exports.InventoryTypeId = exports.SHIPPING_EXCLUDED_STATES = void 0;
var react_1 = __importStar(require("react"));
var TileFunctions_1 = require("./TileFunctions");
exports.SHIPPING_EXCLUDED_STATES = ['AK', 'HI'];
var InventoryTypeId;
(function (InventoryTypeId) {
    InventoryTypeId[InventoryTypeId["Core"] = 1] = "Core";
    InventoryTypeId[InventoryTypeId["WIP"] = 2] = "WIP";
    InventoryTypeId[InventoryTypeId["ThirdParty"] = 3] = "ThirdParty";
    InventoryTypeId[InventoryTypeId["DealerMarketplace"] = 4] = "DealerMarketplace";
})(InventoryTypeId || (exports.InventoryTypeId = InventoryTypeId = {}));
var defaultContext = {
    tileData: {
        year: 0,
        make: '',
        model: '',
        trim: '',
        locationId: 0,
        mileage: 0,
        stockNumber: 0,
        vehicleInventoryType: 0,
        jellyBeanMobileUrl: '',
        vehicleUnlockDateTime: '',
        vehiclePurchaseType: '',
        vehicleTags: [],
        isOnDemand: false,
        previousPrice: 0,
        price: {
            discounts: [],
            total: 0,
            totalDiscountAmount: 0
        },
        vehicleId: 0,
        transportCost: 0
    },
    soonestAvailabilityInfo: {},
    availabilityInfo: {
        pickup: undefined,
        delivery: undefined,
        isLoaded: false
    },
    financeInfo: {
        price: {},
        tradeInApplied: false,
        hasSoftPull: false,
        showFinanceInfo: true
    },
    assets: {
        cvnaVexFastlyImageUrl: '',
        cvnaAppAssetsCdn: ''
    },
    userInfo: {
        location: { state: '' },
        favoriteIds: []
    },
    utils: {
        handleFavorite: function () { },
        openModal: function () { },
        trackEvent: function () { }
    },
    isFavorite: false,
    setIsFavorite: function () { },
    shouldHideShipping: false
};
var TileDataContext = (0, react_1.createContext)(defaultContext);
function useTileDataContext() {
    return (0, react_1.useContext)(TileDataContext);
}
exports.useTileDataContext = useTileDataContext;
var TileDataContextProvider = function (_a) {
    var children = _a.children, tileData = _a.tileData, availabilityInfo = _a.availabilityInfo, financeInfo = _a.financeInfo, assets = _a.assets, userInfo = _a.userInfo, utils = _a.utils;
    var _b = (0, react_1.useState)(userInfo.favoriteIds.includes(tileData.vehicleId)), isFavorite = _b[0], setIsFavorite = _b[1];
    var _c = (0, react_1.useState)({}), soonestAvailabilityInfo = _c[0], setSoonestAvailabilityInfo = _c[1];
    var shouldHideShipping = exports.SHIPPING_EXCLUDED_STATES.includes(userInfo.location.state) ||
        !(availabilityInfo.delivery == null ||
            availabilityInfo.delivery.activityType === 'LocalDelivery');
    (0, react_1.useEffect)(function () {
        if (availabilityInfo.pickup || availabilityInfo.delivery) {
            setSoonestAvailabilityInfo((0, TileFunctions_1.calculateSoonestAvailable)(availabilityInfo));
        }
    }, [availabilityInfo]);
    var value = (0, react_1.useMemo)(function () { return ({
        tileData: tileData,
        assets: assets,
        soonestAvailabilityInfo: soonestAvailabilityInfo,
        availabilityInfo: availabilityInfo,
        financeInfo: financeInfo,
        userInfo: userInfo,
        utils: utils,
        isFavorite: isFavorite,
        setIsFavorite: setIsFavorite,
        shouldHideShipping: shouldHideShipping
    }); }, [
        tileData,
        assets,
        soonestAvailabilityInfo,
        availabilityInfo,
        financeInfo,
        userInfo,
        utils,
        isFavorite,
        shouldHideShipping
    ]);
    return (react_1.default.createElement(TileDataContext.Provider, { value: value }, children));
};
exports.TileDataContextProvider = TileDataContextProvider;
exports.default = TileDataContext;
//# sourceMappingURL=TileDataContext.js.map